module.exports = __webpack_public_path__ + "img/loadingAnimation.4d44910b.svg";